// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1zAWE","containerItemsCenter":"Skeleton_containerItemsCenter__1rnf2"};